<template>
    <div id="defaultLoader">
        <svg :width="svgWidth"  :height="svgHeight"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="background: none;"><circle cx="50" cy="50" fill="none" :stroke="svgStrokeColor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(323.425 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
    </div>
</template>

<script>
export default {
    // name: 'default-loader',
    data: ( )=> ({
        svgWidth: '50px',
        svgHeight: '50px',
        svgStrokeColor: ''
    }),
    created(){
        this.colors = this.$store.getters.getCustomColors,
        this.svgStrokeColor = this.colors.first
    }
}
</script>

<style lang="scss" scoped>
    #defaultLoader{
        display: flex;
        justify-content: center; 
        
        // img{
        //     width: 78px;
        // }   
    }
</style>
